//import { toast } from 'react-toastify';
import toast from '../../../utils/toast';
import api from '../../../services/api';

export const useBulkActions = (filteredSubmissions, selectedSubmissions) => {
  const handleBulkViewDetails = (onViewDetails) => {
    if (selectedSubmissions.size === 1) {
      const submission = filteredSubmissions.find(sub => sub._id === Array.from(selectedSubmissions)[0]);
      onViewDetails(submission);
    } else {
      toast.info('Please select only one submission to view details');
    }
  };

  const handleBulkEdit = (onEditSubmission) => {
    if (selectedSubmissions.size === 1) {
      const submission = filteredSubmissions.find(sub => sub._id === Array.from(selectedSubmissions)[0]);
      onEditSubmission(submission);
    } else {
      toast.info('Please select only one submission to edit');
    }
  };

  const handleBulkSendEmail = (onSendEmail) => {
    const selectedSubs = filteredSubmissions.filter(sub => selectedSubmissions.has(sub._id));
    if (selectedSubs.length > 0) {
      // For now, send email to the first selected submission
      // In the future, this could be enhanced to send bulk emails
      onSendEmail(selectedSubs[0]);
    }
  };

  const handleBulkViewHistory = (onShowHistory) => {
    if (selectedSubmissions.size === 1) {
      const submission = filteredSubmissions.find(sub => sub._id === Array.from(selectedSubmissions)[0]);
      onShowHistory(submission);
    } else {
      toast.info('Please select only one submission to view history');
    }
  };

  const handleBulkDocumentUpload = (onDocumentUpload) => {
    if (selectedSubmissions.size === 1) {
      const submission = filteredSubmissions.find(sub => sub._id === Array.from(selectedSubmissions)[0]);
      onDocumentUpload(submission);
    } else {
      toast.info('Please select only one submission for document upload');
    }
  };

  const handleBulkVerification = (onVerification) => {
    if (selectedSubmissions.size === 1) {
      const submission = filteredSubmissions.find(sub => sub._id === Array.from(selectedSubmissions)[0]);
      onVerification(submission);
    } else {
      toast.info('Please select only one submission for verification');
    }
  };

  const handleBulkCreateInvoice = (onCreateProformaInvoice) => {
    if (selectedSubmissions.size === 1) {
      const submission = filteredSubmissions.find(sub => sub._id === Array.from(selectedSubmissions)[0]);
      onCreateProformaInvoice(submission);
    } else {
      toast.info('Please select only one submission to create invoice');
    }
  };

  const handleBulkDelete = async (onRefresh) => {
    const selectedSubs = filteredSubmissions.filter(sub => selectedSubmissions.has(sub._id));
    if (selectedSubs.length === 0) {
      toast.info('Please select at least one submission to delete');
      return;
    }

    // Confirm deletion
    const confirmMessage = selectedSubs.length === 1 
      ? `Are you sure you want to delete this form submission? This action cannot be undone.`
      : `Are you sure you want to delete ${selectedSubs.length} form submissions? This action cannot be undone.`;

    if (!window.confirm(confirmMessage)) {
      return;
    }

    try {
      // Delete submissions one by one
      const deletePromises = selectedSubs.map(submission => 
        api.delete(`/form-submissions/${submission._id}`)
      );

      await Promise.all(deletePromises);

      toast.success(
        selectedSubs.length === 1 
          ? 'Form submission deleted successfully'
          : `${selectedSubs.length} form submissions deleted successfully`
      );

      // Refresh the submissions list
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      console.error('Error deleting form submissions:', error);
      
      if (error.response?.status === 403) {
        toast.error('You do not have permission to delete form submissions');
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Failed to delete form submissions. Please try again.');
      }
    }
  };

  return {
    handleBulkViewDetails,
    handleBulkEdit,
    handleBulkSendEmail,
    handleBulkViewHistory,
    handleBulkDocumentUpload,
    handleBulkVerification,
    handleBulkCreateInvoice,
    handleBulkDelete
  };
}; 